<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<ng-container *ngIf="!loading.isShow">
  <ng-container *ngIf="error_message">
    <div class="alert alert-danger">
      <button type="button" class="close" data-dismiss="alert" (click)="clearErrors()">×</button>
      {{ error_message }}
    </div>
  </ng-container>

  <div class="page-header">
    <h1 class="page-header__title slds-truncate" title="Document Flow">Document Flow</h1>
    <div class="nav-div">
      <button class="btn btn-primary" (click)="backButton()">&laquo; Back</button>
    </div>
  </div>

  <form [formGroup]="TemplateSettings" class="s-builder">
    <!--ngSubmit)="submitForm()">-->
    <div *ngIf="isFormDisabled" class="s-builder__disabled-form-cover"></div>
    <div class="s-builder__body">
      <!--Builder Section Document Name-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half">
            <div class="s-builder__block-name">Document Flow name</div>
            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <input class="s-builder__input full-width" formControlName="TemplateName" />
              </label>
            </div>
          </div>

          <div class="s-builder__block s-builder__half s-builder__info">
            <div class="s-builder__block-name">&nbsp;</div>
            <p class="s-builder__info-row">
              Enter a name for your Document Flow that will be shown in the list.
            </p>
          </div>
        </div>
      </div>

      <!--Builder Section  Preparations SF Tag-->
      <div class="s-builder__section s-builder__section_dblock">
        <div class="s-builder__section-body-collapse-control">
          <div class="s-builder__form-control-row">
            <div class="s-builder__form-control">
              <label
                class="s-builder__label c-pointer"
                [class.collapsed]="!isTagBuilderExpanded"
                (click)="isTagBuilderExpanded = !isTagBuilderExpanded"
                aria-expanded="false"
              >
                <span class="s-builder__pseudo-checkbox s-builder__input checked-mode"></span>
                <!--<input type="checkbox" class="s-builder__input"/>-->
                <span class="s-builder__control-name">Show tag builder</span>
              </label>
            </div>
          </div>
        </div>

        <div
          class="s-builder__section-body collapse"
          [class.show]="isTagBuilderExpanded"
          id="tag-builder"
          aria-expanded="false"
        >
          <div class="s-builder__block s-builder__half">
            <datalist id="sf-objects-list">
              <option *ngFor="let object of sObjects" value="{{ object }}"></option>
            </datalist>
            <datalist id="sf-object-fields-list">
              <option *ngFor="let fieldItem of RecordFields" value="{{ fieldItem }}"></option>
            </datalist>

            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <span class="s-builder__control-name">Salesforce record type</span>
                <input
                  type="text"
                  class="s-builder__input full-width"
                  list="sf-objects-list"
                  name="sObjects"
                  placeholder="Enter record type"
                  (change)="selectRecordType($event.target.value)"
                />
              </label>
            </div>

            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <span class="s-builder__control-name">Salesforce field name</span>
                <input
                  type="text"
                  class="s-builder__input full-width"
                  list="sf-object-fields-list"
                  name="recordField"
                  placeholder="Enter field name"
                  [value]="selectedRecordField"
                  (change)="selectRecordField($event.target.value)"
                  [disabled]="!selectedRecordType"
                />
              </label>
            </div>
          </div>

          <div class="s-builder__block s-builder__half">
            <label class="s-builder__label">
              <span class="s-builder__control-name">Prepared Salesforce tag</span>
              <p class="s-builder__sf-tag">
                <span *ngIf="!sfTag" class="s-builder__sf-tag_empty">
                  To create a tag, choose the Salesforce object and field with the data you intend to use.
                  Copy a formed tag and insert it wherever needed in the signing invite.
                </span>
                <span *ngIf="sfTag">
                  {{ sfTag }}
                </span>
              </p>
              <button class="btn btn-neutral fl-right" (click)="copyTag(sfTag)" [disabled]="!sfTag">
                Copy
              </button>
            </label>
          </div>
        </div>
      </div>

      <!--Builder Section Roles-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half">
            <div class="s-builder__block-name">Signers</div>

            <div formArrayName="Roles">
              <!--<ng-container *ngFor="let role of Roles; let i = index" [attr.data-index]="i">-->
              <ng-container *ngFor="let role of TemplateSettings.controls.Roles?.controls; let i = index">
                <div class="s-builder__role" [formGroupName]="i">
                  <div class="s-builder__form-control-row">
                    <div class="s-builder__form-control s-builder__role-order">
                      <label class="s-builder__label">
                        <span class="s-builder__control-name">Order</span>
                        <input
                          type="number"
                          class="s-builder__input full-width"
                          min="1"
                          formControlName="order"
                        />
                      </label>
                    </div>
                    <div class="s-builder__form-control s-builder__role-signer">
                      <label class="s-builder__label">
                        <span class="s-builder__control-name">Name</span>
                        <input
                          type="text"
                          class="s-builder__input full-width"
                          placeholder="Name"
                          formControlName="name"
                        />
                      </label>
                    </div>
                    <div class="s-builder__form-control s-builder__role-email">
                      <label class="s-builder__label">
                        <span class="s-builder__control-name">Email</span>
                        <input
                          type="email"
                          class="s-builder__input full-width"
                          placeholder="email@domain.com"
                          formControlName="email"
                        />
                      </label>
                    </div>

                    <div class="s-builder__form-control s-builder__role-btn">
                      <span class="s-builder__control-name dib full-width">&nbsp;</span>
                      <button
                        class="btn btn-primary s-builder__role-btn"
                        (click)="role.expandedAdvancedSettings = !role.expandedAdvancedSettings"
                        title="Advanced settings"
                      >
                        <span class="glyphicon glyphicon-cog"></span>
                      </button>
                    </div>

                    <div class="s-builder__form-control delete-btn">
                      <span class="s-builder__control-name dib full-width">&nbsp;</span>
                      <button class="btn btn-primary s-builder__role-btn" (click)="deleteRole(i)">
                        <span class="glyphicon glyphicon-trash" title="delete role"></span>
                      </button>
                    </div>
                  </div>

                  <div class="collapse" [class.show]="role.expandedAdvancedSettings" id="role-row_{{ i }}">
                    <div class="s-builder__form-control-row">
                      <div class="s-builder__form-control s-builder__role-expiration">
                        <label class="s-builder__label">
                          <span class="s-builder__control-name">Expiration</span>
                          <input
                            type="number"
                            class="s-builder__input full-width"
                            min="1"
                            max="180"
                            formControlName="expiration"
                          />
                        </label>
                      </div>
                      <div class="s-builder__form-control s-builder__role-reminder">
                        <label class="s-builder__label">
                          <span class="s-builder__control-name">Reminder</span>
                          <input
                            type="number"
                            class="s-builder__input full-width"
                            min="0"
                            formControlName="reminder"
                            placeholder="0"
                          />
                        </label>
                      </div>
                      <div class="s-builder__form-control s-builder__role-password">
                        <label class="s-builder__label">
                          <span class="s-builder__control-name">Password</span>
                          <input
                            type="password"
                            class="s-builder__input full-width"
                            formControlName="password"
                            placeholder="Password"
                          />
                        </label>
                      </div>
                    </div>
                    <div class="s-builder__form-control-row">
                      <div class="s-builder__form-control s-builder__role-allow">
                        <label class="s-builder__label">
                          <input
                            type="checkbox"
                            class="s-builder__input s-builder__allow-input"
                            formControlName="is_allow_forwarding"
                          />
                          <span class="s-builder__control-name">Allow Forwarding</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <button class="btn btn-primary s-builder__submit" (click)="addRole()">Add new signer</button>
          </div>

          <div class="s-builder__block s-builder__half s-builder__info">
            <div class="s-builder__block-name">&nbsp;</div>
            <p class="s-builder__info-row">
              Enter names of the signers from a document being sent and specify their emails.
            </p>
            <p class="s-builder__info-row">Specify the order of document signing if needed.</p>
            <p class="s-builder__info-row">
              Check the Allow forwarding box to let signers forward signing invites to other signers.
            </p>
            <p class="s-builder__info-row">
              Specify the number of days until your signature request expires.
            </p>
            <p class="s-builder__info-row">
              Specify the number of days for reminding signers of your signature request.
            </p>
          </div>
        </div>
      </div>

      <!--Builder Section Email Message-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half">
            <div class="s-builder__block-name">Message</div>
            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <span class="s-builder__control-name">Subject</span>
                <input class="s-builder__input full-width" formControlName="Subject" />
              </label>
            </div>

            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <span class="s-builder__control-name">Body</span>
                <textarea class="s-builder__input full-width slds-textarea" formControlName="Body"></textarea>
              </label>
            </div>
          </div>

          <div class="s-builder__block s-builder__half s-builder__info">
            <div class="s-builder__block-name">&nbsp;</div>
            <p class="s-builder__info-row">
              Provide a subject and a brief description of your invite that will be shown to signers once they
              receive your signature request.
            </p>
          </div>
        </div>
      </div>

      <!--Builder Section Document Name-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half">
            <div class="s-builder__block-name">Document name</div>

            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <input class="s-builder__input full-width" formControlName="Name" />
              </label>
            </div>
          </div>

          <div class="s-builder__block s-builder__half s-builder__info">
            <div class="s-builder__block-name">&nbsp;</div>
            <p class="s-builder__info-row">Enter a name for the document being sent for e-signing.</p>
          </div>
        </div>
      </div>

      <!--Builder Section Salesforce Annotation-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half">
            <div class="s-builder__block-name">Salesforce Annotation</div>

            <div class="s-builder__form-control-row" formGroupName="AnnotationConfig">
              <div class="s-builder__form-control half-width">
                <label class="s-builder__label">
                  <span class="s-builder__control-name">Font size</span>
                  <input type="number" class="s-builder__input full-width" formControlName="size" />
                </label>
              </div>
              <div class="s-builder__form-control half-width">
                <label class="s-builder__label">
                  <span class="s-builder__control-name">Line height</span>
                  <input
                    type="number"
                    class="s-builder__input full-width"
                    step=".1"
                    formControlName="line_height"
                  />
                </label>
              </div>
            </div>
          </div>

          <div class="s-builder__block s-builder__half s-builder__info">
            <div class="s-builder__block-name">&nbsp;</div>
            <p class="s-builder__info-row">
              Specify the font size and line height for the text being added to the Salesforce Annotations
              fields.
            </p>
          </div>
        </div>
      </div>

      <!--Builder Section Other Settings-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half">
            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <input
                  type="checkbox"
                  value="allow_forwarding"
                  class="s-builder__input"
                  formControlName="AutomaticallySend"
                />
                <span class="s-builder__control-name">Automatically send</span>
              </label>
            </div>

            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <input
                  type="checkbox"
                  value="allow_forwarding"
                  class="s-builder__input"
                  formControlName="SkipToEnd"
                />
                <span class="s-builder__control-name">Skip to end</span>
              </label>
            </div>

            <div class="s-builder__form-control">
              <label class="s-builder__label">
                <input
                  type="checkbox"
                  value="allow_forwarding"
                  class="s-builder__input"
                  formControlName="HideAdvancedSettings"
                />
                <span class="s-builder__control-name">Hide advanced settings</span>
              </label>
            </div>
          </div>

          <div class="s-builder__block s-builder__half s-builder__info">
            <p class="s-builder__info-row">
              <strong>Automatically send:</strong> Check the Automatically send box to automatically send your
              documents using the SignNow button in your Salesforce object. <br />
            </p>
            <p class="s-builder__info-row">
              <strong>Skip to end:</strong> Check the Skip to end box to make documents automatically open on
              the last step, skipping the document options settings. <br />
            </p>
            <p class="s-builder__info-row">
              <strong>Hide advanced settings</strong> Check the Hide advanced settings box to hide the
              advanced settings section when creating your sending.
            </p>
          </div>
        </div>
      </div>

      <!--Builder Section-->
      <div class="s-builder__section">
        <div class="s-builder__section-body">
          <div class="s-builder__block s-builder__half"></div>
          <div class="s-builder__block s-builder__half">
            <button class="btn btn-success fl-right" type="button" (click)="submitForm()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-container *ngIf="is_template_settings_error">
    <div class="slds-modal-wrap">
      <div tabindex="-1" class="slds-modal slds-fade-in-open">
        <div class="slds-modal__container red-border">
          <header class="slds-modal__header">
            <h2 class="slds-text-heading_medium slds-hyphenate bold">
              {{ templateSettingsFormError.title }}
            </h2>
          </header>
          <div class="slds-modal__content slds-p-around_medium">
            {{ templateSettingsFormError.message }}
          </div>
          <footer class="slds-modal__footer">
            <button class="btn btn-primary" (click)="closeModal()">Ok</button>
          </footer>
        </div>
      </div>
      <div class="slds-backdrop slds-backdrop_open"></div>
    </div>
  </ng-container>
</ng-container>
